import { render, staticRenderFns } from "./compFormTextarea.vue?vue&type=template&id=3800cf21&scoped=true&"
import script from "./compFormTextarea.vue?vue&type=script&lang=js&"
export * from "./compFormTextarea.vue?vue&type=script&lang=js&"
import style0 from "./compFormTextarea.vue?vue&type=style&index=0&id=3800cf21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3800cf21",
  null
  
)

export default component.exports